var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    [
      _c("td", [
        _c("div", {
          staticClass: "dot",
          style: { "background-color": _vm.statusColor }
        })
      ]),
      _vm._v(" "),
      _c("td", [_vm._v(_vm._s(_vm.specification.name))]),
      _vm._v(" "),
      _c("td", { staticClass: "text-left" }, [
        _vm._v(_vm._s(_vm.specification.description))
      ]),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "text-right" },
        [
          _vm.specification.type === _vm.PqtMeasurementValueType.Float
            ? [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.formatValue(
                        _vm.getValue(
                          _vm.specification.lowerBound,
                          _vm.specification.type
                        ),
                        _vm.state.config
                      )
                    ) +
                    "\n    "
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("td", { staticClass: "text-right" }, [
        _vm._v(
          _vm._s(
            _vm.formatValue(
              _vm.getValue(
                _vm.specification.nominalValue,
                _vm.specification.type
              ),
              _vm.state.config
            )
          )
        )
      ]),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "text-right" },
        [
          _vm.specification.type === _vm.PqtMeasurementValueType.Float
            ? [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.formatValue(
                        _vm.getValue(
                          _vm.specification.upperBound,
                          _vm.specification.type
                        ),
                        _vm.state.config
                      )
                    ) +
                    "\n    "
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("td", [
        _vm.isFloat
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.measurement.value,
                  expression: "measurement.value"
                }
              ],
              staticClass: "form-control ml-auto text-right",
              staticStyle: { width: "10em" },
              attrs: { type: "number", step: "0.1" },
              domProps: { value: _vm.measurement.value },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.measurement, "value", $event.target.value)
                }
              }
            })
          : _vm.isString
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.measurement.value,
                  expression: "measurement.value"
                }
              ],
              staticClass: "form-control ml-auto",
              staticStyle: { width: "10em" },
              attrs: { type: "text", maxlength: "32" },
              domProps: { value: _vm.measurement.value },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.measurement, "value", $event.target.value)
                }
              }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.specification.allowSeparateTester
        ? [
            _c("td", [
              _c(
                "div",
                { staticClass: "d-flex flex-row align-items-center" },
                [
                  _c("div", [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.measurement.testDate &&
                            _vm.formatDateTime(_vm.measurement.testDate)
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.measurement.testerName))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary ml-2",
                      on: { click: _vm.enableTesterAndDate }
                    },
                    [
                      _vm.enabledTesterAndDate
                        ? _c("i", { staticClass: "fa fa-edit" })
                        : _c("i", { staticClass: "fa fa-user-plus" })
                    ]
                  ),
                  _vm._v(" "),
                  _c("PqtMeasurementRowSeparateTesterEditModal", {
                    ref: "separateTesterEditModal"
                  })
                ],
                1
              )
            ])
          ]
        : _c("td"),
      _vm._v(" "),
      _c(
        "td",
        _vm._l(_vm.attachments, function(attachment) {
          return _c(
            "div",
            {
              key: attachment.id,
              staticClass: "text-truncate",
              staticStyle: { "max-width": "15em" }
            },
            [
              attachment.media
                ? _c(
                    "a",
                    {
                      attrs: {
                        href: attachment.media.publicUrl,
                        title: attachment.media.filename,
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(attachment.media.filename) +
                          "\n      "
                      )
                    ]
                  )
                : _c("span", [
                    _vm._v(
                      "(" +
                        _vm._s(
                          _vm.$t(
                            "productQualityTests.measurementSpecification.mediaDeleted"
                          )
                        ) +
                        ")"
                    )
                  ])
            ]
          )
        }),
        0
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }